import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000000) return `${(views / 10000000).toFixed(1)}千万`;
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={comic.title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
          {comic.isHot && (
            <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
              新作
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-white'
              : 'bg-secondary-500 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-white leading-tight whitespace-nowrap overflow-hidden text-ellipsis">
            {comic.title}
          </h3>
          <p className="text-xs text-white/70 mt-1 flex items-center gap-2">
            <span>{comic.latestChapter}</span>
          </p>
          <p className="text-xs text-white/60 mt-0.5 flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-[10px]"></i>
              {formatViews(comic.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-[10px] text-accent-400"></i>
              {comic.rating}
            </span>
          </p>
        </div>
      </div>
    </Link>
  );
}